import { gsap } from "../LibrariesImport";

export default class BlockKeyNumbers {
	static init() {
		this.keyNumbers = document.querySelectorAll(".block-key-numbers");

		if (!this.keyNumbers) {
			return;
		}

		this.buildKeyNumbersAnim();
	}

	static buildKeyNumbersAnim() {
		this.keyNumbers.forEach((item) => {
			const numbers = item.querySelectorAll('.key-number');
			const mm = gsap.matchMedia();

			const maxOffset = 200;
			const minOffset = 50;

			numbers.forEach((number) => {
				const initialOffsetY = Math.floor(Math.random() * (maxOffset - minOffset) + minOffset);
				const scrub = 1 + (Math.random() / 2);

				mm.add(`(min-width: 768px)`, () => {
					gsap.set(number, {
						y: initialOffsetY,
					});

					gsap.to(number, {
						y: 0,
						scrollTrigger: {
							trigger: item,
							start: 'top 75%',
							end: 'center 10%',
							once: false,
							scrub: 1.1,
						},
					});
				});
			});
		});
	}
}